export default "__VITE_ASSET___HYzWtSm__"